// extracted by mini-css-extract-plugin
export default {"title":"AssignmentUpload_title__FmJ2N","inputform":"AssignmentUpload_inputform__qPgeE"};